import { SubmissionError } from 'redux-form'
import { getCookieValue } from 'app/actions/genericActionCreator'
import { catchCommonErrors } from 'app/actions/commonActionUtils'
import { convertLgyErrorResponseToFormErrorObject } from 'app/utils/formUtils'

export const searchForUsers = (searchParameters) => {
  return (dispatch) => {
    console.log('Calling searchForUsers with values', searchParameters)
    dispatch(searchingForUsers())
    // the fetch promise object must be returned so that redux form can call .then() on it and know when to turn submitting back to false
    return fetch('/lgyhub/api/users/search', {
      credentials: 'include',
      method: 'POST',
      headers: new Headers({
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-XSRF-TOKEN': getCookieValue('XSRF-TOKEN')
      }),
      body: JSON.stringify(searchParameters)
    }).then((response) => {
      return catchCommonErrors(dispatch, response, 'searching for users')
    }).then((responseJson) => {
      if (responseJson.status >= 400) {
        dispatch(userSearchFailure({ error: responseJson.errors[0].message }))
        throw new SubmissionError(convertLgyErrorResponseToFormErrorObject(responseJson))
      } else { //success
        dispatch(userSearchSuccess(responseJson))
      }
    })
  }
}

export const searchingForUsers = () => ({
  type: 'USER_SEARCH'
})

export const userSearchSuccess = (payload) => ({
  type: 'USER_SEARCH_SUCCESS',
  payload
})

export const userSearchFailure = (payload) => ({
  type: 'USER_SEARCH_FAILURE',
  payload
})